export enum FlatStatus {
  SALE = 'SALE',
  BOOKED = 'BOOKED',
  SOLD = 'SOLD',
  RESERVE = 'RESERVE'
}
